<template>
  <div class="border-dark my-5 p-lg-5 p-4">
    <template>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center"></th>
              <td class="text-center b1">{{ $t("card.fileName") }}</td>
              <td class="text-center b1">{{ $t("orderForm.colorType") }}</td>
              <td class="text-center b1">
                {{ $t("orderForm.bookbindingType") }}
              </td>
              <td class="text-center b1">{{ $t("card.numberOfPages") }}</td>
              <td class="text-center b1">{{ $t("orderForm.series") }}</td>
              <td class="text-center b1">{{ $t("card.price") }}</td>
              <td class="text-center b1">{{ $t("card.download") }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in cartData" :key="item.row">
              <td class="text-center"></td>
              <td class="text-center">{{ item.file_name }}</td>
              <td class="text-center" v-if="item.type == 'BW1'">
                {{ $t("black-white") }}
              </td>
              <td class="text-center" v-if="item.type == 'BW2'">
                {{ $t("both-black-white") }}
              </td>
              <td class="text-center" v-if="item.type == 'RGB1'">
                {{ $t("colorfull") }}
              </td>
              <td class="text-center" v-if="item.type == 'RGB2'">
                {{ $t("both-colorfull") }}
              </td>
              <td class="text-center" v-if="item.bookbinding == 'S'">
                {{ $t("orderForm.bookbinding") }}
              </td>
              <td class="text-center" v-if="item.bookbinding == 'M'">
                {{ $t("orderForm.punch") }}
              </td>
              <td class="text-center" v-if="item.bookbinding == 'N'">
                {{ $t("orderForm.none") }}
              </td>
              <td class="text-center">{{ item.page_number }}</td>
              <td class="text-center">{{ item.print_number }}</td>
              <td class="text-center">{{ item.persian_price }}</td>
              <td class="text-center">
                <a :href="item.file" download>
                  <v-icon>mdi-file-download</v-icon>
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <div class="container">
      <div class="row mb-4">



        <div class="col-lg-6">


          <div class="row b1">
            {{ $t("card.totalPrice") }}
          </div>
          <div class="row greenColor b1">
            {{ totlPrice }}
          </div>
          <div class="mt-5 mr-n4 row" v-if="showPay && transfereeStatus">
            <div align="center" class="
          col-lg-2 col-8
          font14
          orangeBcg
          rounded-pill
          btn-sm
          pointer
          text-light
          max-h
        " v-if="!showDiscountInput" @click="showDiscountInput = !showDiscountInput">
              {{ $t("enterDiscount") }}
            </div>
            <div align="center" class="
          col-lg-2 col-6
          font14
          blue-bcg
          rounded-pill
          btn-sm
          pointer
          text-light
          max-h
          mb-n5
        " v-if="showDiscountInput" @click="askDiscount()">
              {{ $t("addDiscount") }}
            </div>
            <div class="col-lg-3 col-6 mt-n8 mb-n5" v-if="showDiscountInput">
              <v-text-field v-model="discountCode" :label="$t('discountCode')"></v-text-field>
            </div>
          </div>
          <div class="mt-4 mr-n3" v-if="transfereeStatus">
            {{ $t("transferee") }}
            {{ transfereePrice }}
          </div>
          <div class="mt-2 mr-n3" v-if="transfereeStatus">
            {{ $t("allPrice") }}
            {{ allPrice }}
          </div>
          <div class="mt-2 mr-n3" v-if="transfereeStatus">
            {{ $t("discount") }}
            {{ discount }}
          </div>
          <div class="mt-2 mr-n3" v-if="transfereeStatus">
            {{ $t("afterDiscount") }}
            {{ priceAfterDiscount }}
          </div>


        </div>
        <div class="col-lg-6">

          <div class="mt-5 mr-n4 row">
            <div align="center" class="
                col-lg-4 col-8
                font14
                orangeBcg
                rounded-pill
                btn-sm
                pointer
                text-light
                max-h
              " v-if="!showComment" @click="showComment = !showComment">
              <v-icon class="" medium color="white">mdi-plus</v-icon>{{ $t("enterComment") }}
            </div>

            <div class="col-lg-9 col-12 mt-n8 mb-n5" v-if="showComment">
              <v-textarea v-model="description" :label="$t('description')"></v-textarea>
            </div>
          </div>
          <div class="mt-5 mr-n4 row">
            <div align="center" class="
                        col-lg-4 col-8
                        font14
                        blue-bcg
                        rounded-pill
                        btn-sm
                        pointer
                        text-light
                        max-h
                        mb-n5
                        text-center
                      " v-if="showComment" @click="addDescription()">
              {{ $t("addDescriprion") }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="row mt-4 mr-n3" @click="finalPay()" v-if="showPay && transfereeStatus">
          <v-btn class="pay rounded-pill b1 col-lg-3 col-md-3 col-12" @click="finalPay()" dark>
            <v-icon class="m-1">mdi-credit-card-outline</v-icon>{{ $t("card.pay") }}
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      discount: "",
      description: "",
      priceAfterDiscount: "",
      discountCode: "",
      cartData: [],
      totlPrice: "",
      transfereePrice: "",
      allPrice: "",
      showPay: false,
      showComment: false,
      transfereeStatus: false,
      showDiscountInput: false,
    };
  },
  mounted() {
    // اگر صفحه اول یا ثبت سفارش بود/////////////////////////////////////////////////////
    if (
      this.$router.history.current.path == "/panelNewOrder" ||
      this.$router.history.current.path == "/"
    ) {
      this.axios
        .get(this.$session.get("newCartid") + "/final_price")
        .then((response) => {
          console.log(response.data);
          this.allPrice = response.data.sum_t_and_o + this.$t("toman");
          this.discount = response.data.takhfif + this.$t("toman");
          this.priceAfterDiscount = response.data.sum + this.$t("toman");
          this.transfereePrice = response.data.transfer + this.$t("toman");
          if (response.data.transfer) {
            this.transfereeStatus = true;
          } else {
            this.transfereeStatus = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.axios
        .get("order/?cart=" + this.$session.get("newCartid"))
        .then((response) => {
          console.log(response.data[0]);
          this.cartData = response.data[0];
          if (this.cartData.length > 0) {
            this.showPay = true;
          } else {
            this.showPay = false;
          }
          this.axios
            .get("cart/getprice/" + this.$session.get("newCartid"))
            .then((response) => {
              console.log(response.data[0]);
              this.totlPrice = response.data[0] + this.$t("toman");
            });
        });
    } else {
      /////////////////////////////////////////////// اگر صفحه پیگیری////////////////////////////////////////////////////
      const url = window.location.href;
      if (url.includes("tracking")) {
        var trackingCode = url.split("tracking/")[1];
        this.axios
          .get("cart/track?tracking_code=" + trackingCode)
          .then((response) => {
            console.log(response.data);
            this.totlPrice = response.data.persian_price + this.$t("toman");
            this.cartData = response.data.orders;
            this.allPrice = response.data.persian_sum + this.$t("toman");
            this.discount = response.data.takhfif + this.$t("toman");
            this.priceAfterDiscount =
              response.data.persian_sum_p_t + this.$t("toman");
            this.transfereePrice =
              response.data.persian_transfer_price + this.$t("toman");
            if (response.data.persian_transfer_price) {
              this.transfereeStatus = true;
            } else {
              this.transfereeStatus = false;
            }
            this.$emit("details", response.data);
          });
      } else {
        // اگر صفحه جزیات بود///////////////////////////////////////////////////
        this.axios
          .get("cart/" + this.$session.get("oldCartid"))
          .then((response) => {
            console.log(response.data.transferee);
            if (response.data.transferee) {
              this.transfereeStatus = true;
            } else {
              this.transfereeStatus = false;
            }
            this.axios
              .get(this.$session.get("oldCartid") + "/final_price")
              .then((response) => {
                console.log(response.data);
                console.log(response.data.sum);
                this.allPrice = response.data.sum_t_and_o + this.$t("toman");
                this.discount = response.data.takhfif + this.$t("toman");
                this.priceAfterDiscount = response.data.sum + this.$t("toman");
                this.transfereePrice =
                  response.data.transfer + this.$t("toman");
              });
            if (this.$session.get("oldCartid")) {
              this.axios.defaults.headers.common["Authorization"] =
                "Bearer " + this.$session.get("token");
              this.axios
                .get("order/?cart=" + this.$session.get("oldCartid"))
                .then((response) => {
                  console.log(response.data);
                  this.cartData = response.data[0];
                  this.axios
                    .get("cart/" + this.$session.get("oldCartid"))
                    .then((response) => {
                      console.log(response.data.payment_status);
                      if (this.$session.get("oldCartid")) {
                        if (
                          response.data.payment_status == "PrePay" &&
                          this.cartData.length > 0 &&
                          this.transfereeStatus
                        ) {
                          this.showPay = true;
                          this.axios.defaults.headers.common["Authorization"] =
                            "Bearer " + this.$session.get("token");
                          this.axios
                            .post("cart/")
                            .then((response) => {
                              console.log(response.data[0]);
                              this.$session.set("newCartid", response.data[0]);
                              this.$session.set("oldCartid", response.data[0]);
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        } else {
                          this.showPay = false;
                        }
                      } else {
                        if (this.cartData.length > 0) {
                          this.showPay = true;
                        }
                      }
                    });
                  this.axios
                    .get("cart/getprice/" + this.$session.get("oldCartid"))
                    .then((response) => {
                      console.log(response.data[0]);
                      this.totlPrice = response.data[0] + this.$t("toman");
                    });
                });
            }
          });
      }
    }
  },
  methods: {
    askDiscount() {
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      this.axios
        .post("cart/")
        .then((response) => {
          console.log(response);
          this.$session.set("newCartid", response.data[0]);
          this.axios.defaults.headers.common["Authorization"] =
            "Bearer " + this.$session.get("token");
          var postDiscount = {
            discount: this.discountCode,
          };
          this.axios
            .post(
              this.$session.get("newCartid") + "/final_price_takhfif",
              postDiscount
            )
            .then((response) => {
              console.log(response.data);
              this.$noty.success(this.$t("discountAdded"));

              this.allPrice = response.data.sum_t_and_o + this.$t("toman");
              this.discount = response.data.takhfif + this.$t("toman");
              this.priceAfterDiscount = response.data.sum + this.$t("toman");
              this.transfereePrice = response.data.transfer + this.$t("toman");
            })
            .catch((error) => {
              console.log(error);
              this.$noty.error(this.$t("discountIsWrong"));
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addDescription() {
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      this.axios
        .post("cart/", { description: this.description })
        .then((response) => {
          console.log(response);
          this.$noty.success(this.$t("descriptionAdded"));

        })
        .catch((error) => {
          console.log(error);
        });
    },
    finalPay() {
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      var cartid = { pk: this.$session.get("newCartid") };
      this.axios.post("bank", cartid).then((response) => {
        console.log(response.data);
        window.open(response.data, "_self");
        this.$session.remeve("oldCartid");
      });
    },
  },
};
</script>
<style scoped>
.max-h {
  max-height: 30px;
}

.greenColor {
  color: #20db9d;
}

table {
  counter-reset: row-num;
}

table tr {
  counter-increment: row-num;
}

table tr td:first-child::before {
  content: counter(row-num);
}

.pay {
  background-color: #20db6b !important;
}
</style>
